import { Button } from "primereact/button";
import ReactCountryFlag from "react-country-flag";

export default function VendorModal({
  modalRef,
  form,
  editId,
  onChange,
  onSubmit,
  submitLoading,
  validated,
  errors,
  setValidated,
  setErrors,
}) {
  const country_codes = [
    { code: "+62", iso: "ID", label: "Indonesia" },
    { code: "+60", iso: "MY", label: "Malaysia" },
    { code: "+65", iso: "SG", label: "Singapore" },
    { code: "+66", iso: "TH", label: "Thailand" },
    { code: "+84", iso: "VN", label: "Vietnam" },
    { code: "+63", iso: "PH", label: "Philippines" },
    { code: "+1", iso: "US", label: "United States" },
    { code: "+44", iso: "GB", label: "United Kingdom" },
    { code: "+61", iso: "AU", label: "Australia" },
    { code: "+81", iso: "JP", label: "Japan" },
    { code: "+82", iso: "KR", label: "South Korea" },
    { code: "+86", iso: "CN", label: "China" },
    { code: "+91", iso: "IN", label: "India" },
    { code: "+92", iso: "PK", label: "Pakistan" },
    { code: "+971", iso: "AE", label: "UAE" },
    { code: "+966", iso: "SA", label: "Saudi Arabia" },
    { code: "+33", iso: "FR", label: "France" },
    { code: "+49", iso: "DE", label: "Germany" },
    { code: "+39", iso: "IT", label: "Italy" },
    { code: "+34", iso: "ES", label: "Spain" },
    { code: "+7", iso: "RU", label: "Russia" },
    { code: "+55", iso: "BR", label: "Brazil" },
    { code: "+52", iso: "MX", label: "Mexico" },
    { code: "+27", iso: "ZA", label: "South Africa" },
    { code: "+234", iso: "NG", label: "Nigeria" },
    { code: "+90", iso: "TR", label: "Turkey" },
  ];

  const selectedCountry = country_codes.find(
    (c) => c.code === form.country_code
  );

  return (
    <form
      noValidate
      className={validated ? "was-validated" : ""}
      onSubmit={onSubmit}
    >
      <div
        className="modal fade"
        id="vendorModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        ref={modalRef}
      >
        <div className="modal-dialog modal-lg modal-dialog-centered modal-vendor">
          <div className="modal-content shadow-lg border-0 rounded-4">
            {/* HEADER */}
            <div className="modal-header border-0 pb-0">
              <h5 className="modal-title fw-semibold">
                {editId ? "Edit Vendor" : "Tambah Vendor"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              />
            </div>

            {/* BODY */}
            <div className="modal-body pt-3">
              <div className="row g-3">
                {[
                  ["company_name", "Nama Perusahaan"],
                  ["branch", "Cabang"],
                  ["brand", "Merk"],
                  ["sales_name", "Nama Sales"],
                  ["position", "Jabatan"],
                  ["email", "Email", "email"],
                  ["product_type", "Tipe Barang"],
                ].map(([name, label, type = "text"]) => (
                  <div className="col-md-6" key={name}>
                    <div className="form-floating">
                      <input
                        type={type}
                        name={name}
                        value={form[name] ?? ""}
                        onChange={onChange}
                        className={`form-control ${
                          errors[name] ? "is-invalid" : ""
                        }`}
                        placeholder={label}
                        required
                      />
                      <label>{label}</label>
                      <div className="invalid-feedback">
                        {errors[name] || `${label} wajib diisi.`}
                      </div>
                    </div>
                  </div>
                ))}

                {/* NO HP / TELP */}
                <div className="col-md-6">
                  <label className="form-label">No HP / Telp</label>

                  <div className="input-group phone-input-group">
                    {/* FLAG */}
                    <span className="input-group-text flag-box">
                      {selectedCountry && (
                        <ReactCountryFlag
                          svg
                          countryCode={selectedCountry.iso}
                          style={{ width: "1.4em", height: "1.4em" }}
                        />
                      )}
                    </span>

                    {/* COUNTRY CODE */}
                    <select
                      className="form-select country-select"
                      name="country_code"
                      value={form.country_code ?? ""}
                      onChange={onChange}
                    >
                      {country_codes.map((c) => (
                        <option key={c.code} value={c.code}>
                          {c.label} ({c.code})
                        </option>
                      ))}
                    </select>

                    {/* PHONE */}
                    <input
                      type="text"
                      name="phone"
                      value={form.phone ?? ""}
                      onChange={onChange}
                      className={`form-control ${
                        errors.phone ? "is-invalid" : ""
                      }`}
                      placeholder="8123456789"
                      required
                    />

                    <div className="invalid-feedback">
                      {errors.phone || "No HP / Telp wajib diisi."}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* FOOTER */}
            <div className="modal-footer border-top pt-3">
              <Button
                label="Close"
                icon="pi pi-times"
                outlined
                severity="secondary"
                type="button"
                className="rounded px-4"
                data-bs-dismiss="modal"
                onClick={() => {
                  setValidated(false);
                  setErrors({});
                }}
              />
              <Button
                label={
                  submitLoading ? "Memproses..." : editId ? "Update" : "Tambah"
                }
                icon={editId ? "pi pi-save" : "pi pi-plus"}
                severity="primary"
                loading={submitLoading}
                type="submit"
                className="rounded px-4"
              />
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}
